import { Link } from 'react-router-dom';
import { COOKIE_STORAGE_KEY } from '@/components/feature/CookieConsent';

const reopenCookieBanner = () => {
  localStorage.removeItem(COOKIE_STORAGE_KEY);
  window.location.reload();
};

const CTAFooter = () => (
    <>
      {/* CTA */}
      <section className="py-16 sm:py-20 md:py-28 bg-gradient-to-br from-[#862ce0] via-[#9a38e8] to-[#c026d3] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">Start Watching Today</h2>
          <p className="text-lg sm:text-xl text-white/90 mb-8 sm:mb-10 max-w-2xl mx-auto">
            Join thousands of satisfied customers. Activate your subscription in 5 minutes and enjoy thousands of channels.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#test" className="inline-flex items-center justify-center bg-white text-[#862ce0] hover:bg-white/90 font-bold text-lg px-10 py-5 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap">Try Now</a>
            <a href="#test" className="inline-flex items-center justify-center border-2 border-white/40 text-white hover:bg-white/10 font-semibold text-lg px-10 py-5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap">Free 24h Trial</a>
          </div>
          <p className="mt-6 text-white/60 text-sm">✅ Secure payment • ✅ Instant activation • ✅ 7-day guarantee</p>
        </div>
      </section>

      {/* Disclaimer Banner */}
      <div className="bg-gray-950 border-t border-white/10 py-4 px-4">
        <div className="max-w-7xl mx-auto flex items-start gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-gray-500 text-base"></i>
          </div>
          <p className="text-gray-500 text-xs leading-relaxed">
            <strong className="text-gray-400">Disclaimer:</strong> 4K Dream is an independent streaming service and is not affiliated with, endorsed by, or in any way associated with Netflix, Disney+, Amazon Prime Video, Canal+, beIN Sports, or any other third-party platform or broadcaster. All brand names and trademarks mentioned are the property of their respective owners. 4K Dream provides access to its own independently licensed content catalogue.
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 border-t border-white/10 py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-12">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img alt="Logo" className="h-12 w-auto object-contain" src="https://static.readdy.ai/image/5c7545dbb6198b28906c423b0244c4c9/0789dc6d730dd15b6f1e8e24be7c3580.webp" />
              </div>
              <p className="text-gray-400 text-sm">Streaming TV Premium International - Films, Series &amp; TV Channels in 4K</p>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-4 text-white">Services</h3>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>Premium Subscriptions</li><li>Movies &amp; Series 4K</li><li>Live Sport</li><li>Support 7 days/7</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-4 text-white">Contact</h3>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>📞 +1 (205) 709 2376</li><li>📧 support@4k-dream.com</li><li>🕒 Support 7d/7 10h-00h</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-4 text-white">Coverage</h3>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>🌍 Europe</li><li>🌍 America</li><li>🌍 Africa</li><li>🌍 Worldwide</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold text-lg mb-4 text-white">Legal</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/about" className="text-gray-400 hover:text-[#b47ef3] transition-colors cursor-pointer">About Us</Link></li>
                <li>
                  <Link to="/terms" className="text-gray-400 hover:text-[#b47ef3] transition-colors cursor-pointer">
                    Terms &amp; Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-gray-400 hover:text-[#b47ef3] transition-colors cursor-pointer">
                    Privacy Policy
                  </Link>
                </li>
                <li><Link to="/refund" className="text-gray-400 hover:text-[#b47ef3] transition-colors cursor-pointer">Refund Policy</Link></li>
                <li><a href="#support" className="text-gray-400 hover:text-[#b47ef3] transition-colors">Contact</a></li>
                <li>
                  <button
                    type="button"
                    onClick={reopenCookieBanner}
                    className="text-gray-400 hover:text-[#b47ef3] transition-colors cursor-pointer text-sm text-left"
                  >
                    Cookie Settings
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/10 pt-8 text-center text-gray-500 text-sm flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 flex-wrap">
            <p>4K Dream 2019-2026 © All Rights Reserved</p>
            <span className="hidden sm:inline text-gray-700">·</span>
            <Link to="/about" className="hover:text-[#b47ef3] transition-colors cursor-pointer whitespace-nowrap">About Us</Link>
            <span className="hidden sm:inline text-gray-700">·</span>
            <Link to="/privacy" className="hover:text-[#b47ef3] transition-colors cursor-pointer whitespace-nowrap">Privacy Policy</Link>
            <span className="hidden sm:inline text-gray-700">·</span>
            <Link to="/terms" className="hover:text-[#b47ef3] transition-colors cursor-pointer whitespace-nowrap">Terms &amp; Conditions</Link>
            <span className="hidden sm:inline text-gray-700">·</span>
            <Link to="/refund" className="hover:text-emerald-400 transition-colors cursor-pointer whitespace-nowrap">Refund Policy</Link>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="group relative">
          <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping"></span>
          <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap pointer-events-none opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 shadow-lg">
            Chat with us!
            <span className="absolute right-[-6px] top-1/2 -translate-y-1/2 border-4 border-transparent border-l-gray-900"></span>
          </span>
          <a href="https://wa.me/12057092376" target="_blank" rel="noopener noreferrer" className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20BA5A] text-white flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer shadow-lg" aria-label="Contact via WhatsApp">
            <i className="ri-whatsapp-line text-3xl"></i>
          </a>
        </div>
      </div>
    </>
  );

export default CTAFooter;
